import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import { usePostCreatePaymentTermMutation,useTotalModeOfPaymentListMutation } from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { usePageState } from "../../../../Hook/usePageState";
const CreateForm = () => {
  const navigate = useNavigate();
  // const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  // api varibale
  const [CreatePaymentTerm] = usePostCreatePaymentTermMutation();
  const [ModeOfPaymentListApi] = useTotalModeOfPaymentListMutation();

  // tab1
    const [ModeofPayment_list, setModeofPayment_list] = useState([]);
  // const [select_ModeofPayment, setselect_ModeofPayment] = useState("");
  // const [InvoicePortion, setInvoicePortion] = useState("");
  
  // const [DiscountValidityBasedOn, setDiscountValidityBasedOn] = useState("");
  // const [DiscountValidity, setDiscountValidity] = useState("");
  // const [Description, setDescription] = useState("");

  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
   PaymentTermName: false,
   ModeofPayment: false,
      DueDateBasedOn: false,
      CreditDays: false,
      Discount: false,
      DiscountType: false,
  });


  const pageStateDefault = {
    tab: 1,
    PaymentTermName: '',
   select_ModeofPayment: '',
      DueDateBasedOn: '',
      CreditDays: '',
      Discount: '',
      DiscountType: '',
      InvoicePortion:'',
      DiscountValidityBasedOn:'',
      DiscountValidity:'',
      Description:''


  };

  const [pageState, setPageState] = usePageState(`Create Payment Term`, pageStateDefault);


      
  const { tab,PaymentTermName,select_ModeofPayment,DueDateBasedOn,CreditDays,Discount,DiscountType, InvoicePortion,
      DiscountValidityBasedOn,
      DiscountValidity,
      Description} = pageState;

  useEffect(() => {
     const getItemModeofPayment = async () => {
        const ItemModeofPaymentApiData = await ModeOfPaymentListApi()
        setModeofPayment_list(ItemModeofPaymentApiData.data.data);
      }

   
 
    getItemModeofPayment();
    
  }, []);


  const handleSubmit = async () => {

 

    setFieldErrors({
      PaymentTermName: false,
      ModeofPayment: false,
      DueDateBasedOn: false,
      CreditDays: false,
      Discount: false,
      DiscountType: false,
    });

    let hasError = false;
    const newErrors = {
      ModeofPayment: !select_ModeofPayment,
      PaymentTermName: !PaymentTermName,
    };

    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some((error) => error);

    if (!PaymentTermName) {
      setptype("Error");
      setError("Please Select Payment Term Name.");
      setShowError(true);
      return;
    }
    if (!select_ModeofPayment) {
      setptype("Error");
      setError("Please Select Mode of Payment.");
      setShowError(true);
      return;
    }
    

   
  

  const payload = {
    mode_of_payment: select_ModeofPayment,
    invoice_portion: InvoicePortion,
    due_date_based_on: DueDateBasedOn,
    payment_term_name: PaymentTermName,
    credit_days: CreditDays,
    discount_type: DiscountType,
    discount: Discount,
    discount_validity_based_on: DiscountValidityBasedOn,
    discount_validity: DiscountValidity,
    description: Description,
  };

  console.log("create payment term payload:", payload);
    try {
      const response = await CreatePaymentTerm(payload); // RTK mutation or fetch

       function stripHTML(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

if (response.error) {
  let errorMessage = "Creation failed";

  if (response.error.data && response.error.data._server_messages) {
    try {
      const serverMessages = JSON.parse(response.error.data._server_messages);
      if (Array.isArray(serverMessages) && serverMessages.length > 0) {
        const parsedMessage = JSON.parse(serverMessages[0]);
        errorMessage = parsedMessage.message || errorMessage;
      }
    } catch (e) {
      console.warn("Failed to parse _server_messages", e);
    }
  } else {
    errorMessage =
      response.error.data?.message ||
      response.error.data?.exception ||
      errorMessage;
  }

  // ✅ Strip any HTML tags like <strong> from the final error message
  errorMessage = stripHTML(errorMessage);

  setptype("Error");
  setError(errorMessage);
  setShowError(true);
  return;
}

      setpo_response(response.data);
      setError("Payment Term created successfully!");
      setptype("Success");
      setShowError(true);
      // Navigate after a short delay (e.g., 2 seconds)
      setTimeout(() => {
        navigate("/master/payment-term/payment-term-list"); // 🔁 Replace with your actual route
      }, 2000);
    } catch (err) {
      setError(err?.data?.message || "Unexpected error occurred.");
      setptype("Error");
      setShowError(true);
    }
  };
  return (
    <FormLayoutTwo
      title="New Payment Term"
      breadcrumbs={[
        { label: "Payment Term"},
        { label: "Payment Term List", url: "/master/payment-term/payment-term-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => {}}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-bluecolor d-flex"
            iconName="BiCloudUpload"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            Upload
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrCopy"
            iconSize={12}
          >
            Duplicate
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            {po_response.result ? "Submit" : "Save"}
          </Button>

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                   setPageState({ ...pageState, tab: 1 })
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            <div
              className="d-flex align-items-center mb-2 px-3"
              style={{ gap: "2px", fontSize: "12px" }}
            >
             <span style={{ position: "relative", top: "-1px" }}>
  <GetIcon className="text-[#4B002B]" iconName="CgAttachment" size={12} />
</span>
<span className="fw-semibold" style={{ color: "#4B002B" }}>
  Attachments
</span> 
            </div>
          </div>
        </div>


 <div className=" " style={{ background: '' }}>
          <div className="row">
            <div className="col-12">
              <div >
               <Tab1
                    
                     ModeofPayment = {{
                      ModeofPayment_list: ModeofPayment_list,
                      value: pageState.select_ModeofPayment,
                      setValue: (val) => setPageState({ ...pageState, select_ModeofPayment: val }),
                      error: fieldErrors.select_ModeofPayment
                    }}
                      DueDateBasedOn={{
                      value: pageState.DueDateBasedOn,
                      setValue: (val) => setPageState({ ...pageState, DueDateBasedOn: val }),
                      error: fieldErrors.DueDateBasedOn,
                  
                    }}
   PaymentTermName={{
                      value: pageState.PaymentTermName,
                      setValue: (val) => setPageState({ ...pageState, PaymentTermName: val }),
                      error: fieldErrors.PaymentTermName,
                    }}
              CreditDays={{
                      value: pageState.CreditDays,
                      setValue: (val) => setPageState({ ...pageState, CreditDays: val }),
                      error: fieldErrors.CreditDays,
                    }}        
              DiscountType={{
                      value: pageState.DiscountType,
                      setValue: (val) => setPageState({ ...pageState, DiscountType: val }),
                      error: fieldErrors.DiscountType,
                    }}   
                      Discount={{
                      value: pageState.Discount,
                      setValue: (val) => setPageState({ ...pageState, Discount: val }),
                      error: fieldErrors.Discount,
                    }}        
                    
                     InvoicePortion={{
                      value: pageState.InvoicePortion,
                      setValue: (val) => setPageState({ ...pageState, InvoicePortion: val }),
                      error: fieldErrors.InvoicePortion,
                    }}      
                     Description={{
                      value: pageState.Description,
                      setValue: (val) => setPageState({ ...pageState, Description: val }),
                      error: fieldErrors.Description,
                    }}      
                     DiscountValidityBasedOn={{
                      value: pageState.DiscountValidityBasedOn,
                      setValue: (val) => setPageState({ ...pageState, DiscountValidityBasedOn: val }),
                      error: fieldErrors.DiscountValidityBasedOn,
                    }}      
                     DiscountValidity={{
                      value: pageState.DiscountValidity,
                      setValue: (val) => setPageState({ ...pageState, DiscountValidity: val }),
                      error: fieldErrors.DiscountValidity,
                    }}      
                    
                      
                     
                    
                  />
              </div>
            </div>
          </div>
        </div>
      

       
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayoutTwo>
  );
};

export default CreateForm;
